import clsx from "clsx";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";
import type { CampaignOutreachType } from "common/types";

import { CAMPAIGN_OUTREACH_OPTIONS } from "../../../constants";
import useCampaignMetrics from "../../../datahooks/useCampaignMetrics";

interface SuccessTagProps {
  size: "sm" | "md";
  campaignId: string;
  outreachType: CampaignOutreachType;
}

export default function SuccessTag({
  size,
  campaignId,
  outreachType,
}: SuccessTagProps) {
  const { campaignMetrics, isLoadingCampaignMetrics } =
    useCampaignMetrics(campaignId);

  if (isLoadingCampaignMetrics) {
    return (
      <Skeleton className={clsx(size === "md" ? "h-6 w-24" : "h-5 w-20")} />
    );
  } else if (campaignMetrics) {
    const successStringValue =
      CAMPAIGN_OUTREACH_OPTIONS[outreachType].getSuccessString(campaignMetrics);
    // biome-ignore lint/security/noGlobalEval: this usage is safe since the value comes from the server
    const successNumberValue = eval(successStringValue);

    return (
      <Tag variant="tertiary" size={size}>
        ({successStringValue}){" "}
        {successNumberValue ? Math.round(successNumberValue * 100) : 0}%
      </Tag>
    );
  }
}
